module.exports = __webpack_public_path__ + "img/table.d5c5758a.png";